<template>
	<span>
		<span v-if="transportation.isActive === 'false'">
			<b-badge variant="secondary">Inactive</b-badge>
		</span>
		<span v-else>
			<b-badge variant="success">Active</b-badge>
		</span>
	</span>
</template>

<script>
export default {
	name: 'transportation-status',
	props: {
		transportation: {
			type: Object,
			required: true
		}
	}
};
</script>

<style></style>